module.exports = __webpack_public_path__ + "img/shop_home_webshop.24ae18c.svg";